// extracted by mini-css-extract-plugin
module.exports = {"bg":"Modal__bg__2TDwK"};